<template>
  <div class="video-crawler-test-result-table-container">
    <div class="video-crawler-test-result-table container-fluid">
      <table class="table table-borderless result-table">
        <tbody>
          <tr v-for="(value, key, index) in testResult" :key="`${key}${index}`">
            <td width="10%" class="wrap bold" v-if="shouldShowData(key)">{{ key }}</td>
            <td width="90%" class="wrap black" v-if="shouldShowData(key)">
              <a :href="value" v-if="isImageUrl(key)">{{ value }}</a>
              <div v-else-if="!isImageUrl(key)">{{ value }}</div>
              <div class="text-danger" v-if="!value">** ไม่พบข้อมูลวิดีโอนี้</div>
              <img class="display-image" :src="value" v-if="isImageUrl(key)" />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="result-list">
        <ul class="list-group">
          <div class="result-group-item" v-for="(value, key, index) in testResult" :key="`${key}${index}`">
            <div class="wrap bold" v-if="shouldShowData(key)">{{ key }}</div>
            <div class="wrap black" v-if="shouldShowData(key)">
              <a :href="value" v-if="isImageUrl(key)">{{ value }}</a>
              <div v-else-if="!isImageUrl(key)">{{ value }}</div>
              <div class="text-danger" v-if="!value">** ไม่พบข้อมูลวิดีโอนี้</div>
              <img class="display-image" :src="value" v-if="isImageUrl(key)" />
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: ['testResult'],
  data() {
    return {
      validDataName: [
        'title',
        'subTitle',
        'coverImageUrl',
      ],
    };
  },
  methods: {
    shouldShowData(name) {
      return _.indexOf(this.validDataName, name) > -1;
    },
    isImageUrl(name) {
      return name === 'coverImageUrl';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
table {
  table-layout: fixed;
  width: 100%;
}

.result-list {
  display: none;
}

.result-group-item {
  padding: $spacer;
}

.display-image {
  width: 400px;
  padding: $spacer;
}

.wrap {
  word-wrap: break-word;
}

.bold {
  color: $gray-600;
  padding-bottom: $spacer * .5;
  font-weight: bold;
  border-right: 1px dashed $gray-300;
}

.black {
  color: $gray-600;
}

@media (max-width: 575.98px) {
  .result-list {
    display: block;
  }
  .result-table {
    display: none;
  }
  .bold {
    border-right: none;
  }
  .display-image {
    width: 100%;
    padding: 0;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
